module.exports = __webpack_public_path__ + "img/browse-vehicles-search-hero-cjdr.bc36ba03.jpg";